import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'topo-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent implements OnInit {

  @Input() checked: boolean;
  @Input() indeterminate: boolean;
  @Input() disabled: boolean;
  @Output() checkChanged = new EventEmitter();

  constructor() {}

  ngOnInit(): void { }

  onCheckChanged(): void {
    if (this.disabled === true) {
      return;
    }
    this.indeterminate = false;
    this.checkChanged.emit();
  }
}
